export default __webpack_public_path__ + "static/media/check-mark.cad84a4c.png";